'use strict';

angular.module('dealerware.web.data').factory('ConvertUnits', function() {
  const GALLONS_PER_LITER = 0.264172;
  const MILES_PER_KILOMETER = 0.621371;

  function kmToMiles(km) {
    const value = parseFloat(km);
    return value * MILES_PER_KILOMETER;
  }

  function litersToGallons(liters) {
    const value = parseFloat(liters);
    return value * GALLONS_PER_LITER;
  }

  return {
    kmToMiles,
    litersToGallons,
  };
});
